/**
 * ************************************
 *
 * @module  ReactSelectStyles.ts
 * @author  Matt P
 * @date    10/07/2021
 * @description home for the functions which return styling objects used for the
 * various react-select components used throughout the CMS
 *
 * ************************************
 */
// ----------------------------------------------------------------------------|
//                             Styling Functions
// ----------------------------------------------------------------------------|
/**
 * @description tag dropdown styling for the <Select> component
 */
const tagDropdownStyling = (): { [key: string]: any } => ({
  control: (styles: { [key: string]: string }) => ({
    ...styles,
    // none of react-select's styles are passed to <Control />
    minHeight: '44px',
    maxHeight: '75px',
    overflowY: 'auto',
    boxShadow: 'none',
    border: '1px solid rgba(168, 164, 160, 0.5)',
    ':hover': {
      border: '1px solid rgba(168, 164, 160, 0.5)',
    },
  }),
  placeholder: (styles: { [key: string]: string }) => ({
    ...styles,
    fontFamily: 'Libre Franklin', // $libre-franklin
    fontSize: '14.5px',
    padding: '13px 4px',
    color: '#a8a4a0',
    fontWeight: '400',
  }),
  menuList: (styles: { [key: string]: string }) => ({
    ...styles,
    maxHeight: '200px',
  }),
  option: (
    styles: { [key: string]: string },
    { isFocused }: { isFocused: boolean }
  ) => ({
    ...styles,
    cursor: 'pointer',
    backgroundColor: 'white',
    color: isFocused ? '#f7bc25' : 'black',
    ':hover': {
      color: '#f7bc25',
      backgroundColor: 'white',
    },
    ':active': {
      color: '#f7bc25',
      backgroundColor: 'white',
    },
    ':selected': {
      color: '#f7bc25',
      backgroundColor: 'white',
      outline: 'none',
    },
  }),
  multiValue: (styles: { [key: string]: string }) => ({
    ...styles,
    display: 'flex',
    alignItems: 'center',
    minHeight: '25px',
    backgroundColor: '#f0f0f0', // $grey9
    borderRadius: '50px',
    color: '#7c8e9a',
    padding: '3px 8px',
    marginRight: '6px',
    marginTop: '2px',
    marginBottom: '2px',
    cursor: 'pointer',
  }),
  multiValueLabel: (styles: { [key: string]: string }) => ({
    ...styles,
    fontFamily: 'Libre Franklin', // $libre-franklin
    fontWeight: '600',
    color: '#353029', // $text-color
    fontSize: '12px',
    lineHeight: '14.54px',
    margin: '0px',
    paddingRight: '0px',
  }),
  multiValueRemove: (styles: { [key: string]: string }) => ({
    ...styles,
    color: '#353029',
    ':hover': {
      color: '#716c67',
    },
  }),
});

// ----------------------------------------------------------------------------|
//                                 Exports
// ----------------------------------------------------------------------------|
export { tagDropdownStyling };
